'use strict'
import { RECEIVE_ALL_CREDIT_TYPE, RECEIVE_USER_CREDIT, RECEIVE_USER_CREDIT_HISTORY, RESET_CREDITS_INFORMATION } from '../constants/CreditConstants'
import DtoUserCredit from '../dto/DtoUserCredit'
import DtoCreditType from '../dto/DtoCreditType'
import DtoUserCreditHistory from '../dto/DtoUserCreditHistory'


export const store = {
	userCredit: {},
	userCreditHistory: [],
	creditTypes: []
}

export function CreditReducer(state = {}, action) {
	switch (action.type) {
		case RECEIVE_USER_CREDIT: {
			if (action.userCredit && action.userCredit.length) {
				return Object.assign({}, state, {
					userCredit: new DtoUserCredit(action.userCredit[0])
				})
			}
			return Object.assign({}, state, {
				userCredit: {}
			})
		}
		case RECEIVE_USER_CREDIT_HISTORY: {
			return Object.assign({}, state, {
				userCreditHistory: action.userCreditHistory.map((o) => {
					return new DtoUserCreditHistory(o)
				})
			})
		}
		case RECEIVE_ALL_CREDIT_TYPE:
			return Object.assign({}, state, {
				creditTypes: action.creditTypes.map((o) => {
					return new DtoCreditType(o)
				})
			})
		case RESET_CREDITS_INFORMATION:
			return Object.assign({}, state, store)
		default:
			return state
	}
}




// WEBPACK FOOTER //
// ./src/home/reducers/CreditReducer.js